import React from 'react';
import ConfiguredDashboardPage from 'src/mtska-frontend-modules/modules/_shared/dashboardConfigured/ConfiguredDashboardPage';
import { DashboardFiltersStorageKeyProvider } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/DashboardFiltersStorageKeyContext';
import { resolvePageFiltersConfig } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/resolvePageFiltersConfig';
import Overview from '../Overview.jsx';
import { graphComponentRegistry, rentalFleetFiltersTransformRegistry } from './reportRegistry';

const withFiltersStorageProvider = (component, filtersStorageKey) => {
    if (filtersStorageKey === undefined || filtersStorageKey === null || filtersStorageKey === '') {
        return component;
    }

    return (
        <DashboardFiltersStorageKeyProvider value={filtersStorageKey}>{component}</DashboardFiltersStorageKeyProvider>
    );
};

const keyOf = (prefix, ...parts) => [prefix, ...parts].filter(Boolean).join('-');

export const getRentalRunningReportTitle = (reportConfiguration) =>
    reportConfiguration?.report?.title || 'Stato parco';

export const resolveRentalRunningReport = ({
    t,
    filters,
    onClearFilters,
    keyPrefix = 'rental',
    filtersStorageKey = 'dashboard/rentalFleet',
    reportConfiguration,
}) => {
    const sections = reportConfiguration?.report?.sections || [];

    return sections.map((section) => ({
        id: section.id,
        title: t(section.label || section.title),
        icon: section.icon,
        requiredPrivileges: section.requiredPrivileges || [],
        pages: (section.pages || []).map((page) => {
            const pageFiltersConfig = resolvePageFiltersConfig(reportConfiguration, page.filterSetKey);
            const filterCatalog = reportConfiguration?.filters || {};
            const pageKey = keyOf(keyPrefix, section.id, page.id);
            const sectionTitle = t(section.title || section.label || '');
            const pageLabel = t(page.label || page.title || '');
            const pageTitle = (
                <>
                    {pageLabel ? <span>{pageLabel}</span> : null}
                    {sectionTitle ? (
                        <span
                            style={{
                                opacity: 0.5,
                                marginLeft: pageLabel ? '0.35em' : undefined,
                            }}
                        >
                            {sectionTitle}
                        </span>
                    ) : null}
                </>
            );

            const pageComponent = (
                <ConfiguredDashboardPage
                    page={page}
                    pageTitle={pageTitle}
                    dataProviderName={filtersStorageKey}
                    defaultFilters={filters}
                    pageFiltersConfig={pageFiltersConfig}
                    filterSetName={page.filterSetKey}
                    filterCatalog={filterCatalog}
                    graphComponentRegistry={graphComponentRegistry}
                    pageKey={pageKey}
                    filtersTransformRegistry={rentalFleetFiltersTransformRegistry}
                    showFilterSetLabel={false}
                    OverviewComponent={Overview}
                    onClearFilters={onClearFilters}
                />
            );

            return {
                id: page.id,
                title: pageLabel,
                icon: page.icon,
                requiredPrivileges: page.requiredPrivileges || [],
                component: withFiltersStorageProvider(pageComponent, filtersStorageKey),
            };
        }),
    }));
};
